import { trpc } from "#/lib/trpc/client"
import { useQuery } from "@tanstack/react-query"

export function useIntakeForm(appointmentId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["telemedicine", "getIntakeForm", appointmentId],
    queryFn: () => trpc.telemedicine.getIntakeForm.query({ appointmentId }),
    enabled: enabled && Boolean(appointmentId),
    refetchOnWindowFocus: false,
    staleTime: Infinity
  })
}
